import React from 'react'
import showroom from "../images/Interior_photo.jpg";
function Aboutus() {
  return (
    <div>
        <div className="album py-0">
        <div className="container">
        <div className="row">
        <div className="col-md-4">
          <div className='fontbig'>
          <h1 className='mb-0'>About Us</h1>
          <hr/>
          </div>
          </div>
          </div>
          </div>
          </div>

          <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-7 mt-3">
            <div className="card-body">
    <h5 className="card-title mb-2">About Aneek Textiles</h5>
    <p className="card-text justify">Established in the heart of Ranaghat, West Bengal, Aneek Textiles is a trusted name in the world of garments manufacturing and retail. With a passion for quality craftsmanship and a deep-rooted commitment to customer satisfaction, we bring to life a wide range of stylish, durable, and affordable clothing for men, women, and children.</p>

    <p className="card-text justify">At Aneek Textiles, we combine traditional textile expertise with modern manufacturing techniques to produce garments that reflect elegance, comfort, and cultural richness. Our in-house production unit ensures stringent quality control, timely delivery, and customization options for bulk orders and wholesale clients.</p>
    <p className="card-text justify">Our retail showroom offers a curated collection of ethnic wear, casuals, formals, and seasonal fashion that cater to diverse tastes and occasions. Whether you are shopping for everyday wear or something special, Aneek Textiles is your one-stop destination for style and reliability.</p>
 
  </div>
             </div>
                <div className="col-md-5 mt-3">
  <img src={showroom} className="card-img-top" alt="showroom"/>

             </div>
             </div>
             </div>
             </div>
<br/>
    </div>
  )
}

export default Aboutus